<ng-container *ngIf="showConnectionNav">
  <ng-container *ngIf="userLoggedIn">
    <div class="lowConnection d-none">
      <div class="container">
        <div class="row lowConnectionRow">
          <div class="leftWrap">
            Real-Time update
            <div class="tooltip-custom">
              <img alt="info-icon" src="../assets/images/info.svg" />
              <div class="top">
                <p>
                  {{
                    toggleSwitchOn
                      ? "Turn off real-time updates if you are experiencing slow internet connection."
                      : "Real time updates are currently disabled. Please refresh your lot manually to get latest updates!"
                  }}
                </p>
                <i></i>
              </div>
            </div>
          </div>

          <div class="rightWrap">
            <div class="rightWrapInner">
              <label class="switch-slider mr-2">
                <input
                  type="checkbox"
                  class="form-check-input1 slide-check-input"
                  [checked]="toggleSwitchOn"
                  (change)="toggleChange($event)"
                />
                <span class="slider round"></span>
              </label>
              <span class="slideStatus">{{
                toggleSwitchOn ? "On" : "Off"
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
